(() => {
  // Delivery details belong to this tab and invitation, never a shared catalog
  // or long-lived browser record. Keep only fields the recipient can edit.
  const limits = {full_name:256,instagram:512,tiktok:512,address:512,address_2:256,city:256,province:256,postal_code:64,country:256,phone:64,email:320};
  const lifetime = 60 * 60 * 1000;
  function values(input) {
    const result = {};
    for (const [name,limit] of Object.entries(limits)) {
      if (typeof input?.[name] === 'string') result[name] = input[name];
    }
    return result;
  }
  function create(storage, key, now = Date.now) {
    const clear = () => { try { storage?.removeItem(key); } catch (_) {} };
    return {
      clear,
      read() {
        try {
          const draft = JSON.parse(storage?.getItem(key) || 'null');
          if (!draft) return null;
          const age = now() - draft.at;
          if (draft.version !== 1 || !Number.isFinite(draft.at) || age < 0 || age >= lifetime || !draft.fields || typeof draft.fields !== 'object' || Array.isArray(draft.fields)) {
            clear();
            return null;
          }
          return {fields:values(draft.fields),pending:draft.pending === true};
        } catch (_) { clear(); return null; }
      },
      save(fields, pending = false) {
        try {
          storage?.setItem(key,JSON.stringify({version:1,at:now(),fields:values(fields),pending:pending === true}));
          return Boolean(storage);
        } catch (_) { return false; }
      },
    };
  }
  function canRestore(draft, fields, selection, storedSelection) {
    if (!draft?.fields || !Array.isArray(selection) || !selection.length) return false;
    if (Object.entries(fields).some(([name,value]) => draft.fields?.[name] !== value)) return false;
    return JSON.stringify(selection) === storedSelection;
  }
  window.UrbanGiftingDraft = {create,canRestore};
})();
